import { APITagAttributes } from '@ardoq/api-types';
import { TagGroup, Tag, StatusType } from '@ardoq/status-ui';

type TagsProps = {
  tags: APITagAttributes[];
};

const Tags = ({ tags }: TagsProps) => {
  return (
    <TagGroup>
      {tags.map(tag => (
        <Tag key={tag._id} statusType={StatusType.INFO} label={tag.name} />
      ))}
    </TagGroup>
  );
};

export { Tags };
